import { Fragment } from "react";
import { UseNavigationContext } from "../Contexts/NavigationContext";
import { UseUserContext } from "../Contexts/UserContext";
import Ad from "../Generic/Ad";
import ArmanetAd from "../Generic/ArmanetAd";
import ListVideoPlayer from "./ListVideoPlayer";
import VideoListing from "./VideoListing";
import useIsMobile from "../../Hooks/useIsMobile";
import { useMemo } from "react";

function VideoListMultiRow(props) {
  const { user } = UseUserContext();
  const { HandleLinkClick } = UseNavigationContext();
  const { isMobile } = useIsMobile();
  let videoArray = props.videos ?? Array(props.numberOfPlaceholders).fill(null);

  const isOnSingleVideoPage = useMemo(
    () => window.location.pathname.substring(0, 7) === "/video/",
    [window.location.pathname],
  );

  function GetVideoListingClass() {
    return "videoListing" + (props.biggerThumbnails ? " biggerThumbnail" : "");
  }

  function ShouldShowAd(index, bypass = false) {
    // return false;
    if (
      (props.videos?.length === 0 && !props.listComplete) ||
      user?.isPremium ||
      index === 0
    ) {
      return false;
    }
    if (bypass) {
      return true;
    }

    if (props.isRecommendedAndMobile && index === 2 && props.firstList) {
      return true;
    } else if (props.isRecommendedAndMobile && !props.firstList) return false;

    let videosBetweenAds = Math.floor(
      props.videos?.length / (props.numberOfAdsInMiddle + 1),
    );

    if (props.isRecommendedAndMobile && props.firstList) return false;

    return (
      index % videosBetweenAds === 0 &&
      props.videos.length - index > videosBetweenAds / 2
    );
  }

  return (
    <>
      {!props.hideHeader ? (
        <div className="videoListTitleSection">
          <div className="videoListTitle">{props.title}</div>
          {props.moreLink != null ? (
            <a
              href={props.moreLink}
              className="videoListMore"
              onClick={(e) => {
                HandleLinkClick(e, props.moreLink);
              }}
            >
              MORE
            </a>
          ) : null}
        </div>
      ) : null}
      <div className={"videoListInner" + (props.singleRow ? " singleRow" : "")}>
        <div
          className={
            "videoListGrid container" + (props.singleRow ? " singleRow" : "")
          }
        >
          <div
            className={"videoListGrid" + (props.singleRow ? " singleRow" : "")}
          >
            {/* List Video Player */}
            {props.topVideo && !props.singleRow && props.videos?.length > 0 && (
              <>
                {isMobile ? (
                  <div
                    className="topVideoPlayer"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      minWidth: "100%",
                    }}
                  >
                    <ListVideoPlayer topVideo={props.topVideo} />
                    <Ad type={"banner"} />
                  </div>
                ) : (
                  <div className="topVideoPlayer">
                    <ListVideoPlayer topVideo={props.topVideo} />
                    <ArmanetAd type="leaderboard" />
                  </div>
                )}
              </>
            )}
            {props.showArmanetRectangle && !user?.isPremium && (props.armanetRectanglePosition == null || props.armanetRectanglePosition === 0) && (
              <div className={GetVideoListingClass()}>
                <ArmanetAd type="rectangle" />
              </div>
            )}
            {ShouldShowAd(-1, props.adAtStart) && !(props.showArmanetRectangle && !user?.isPremium && (props.armanetRectanglePosition == null || props.armanetRectanglePosition === 0)) && (
              <div
                className={
                  GetVideoListingClass() +
                  (!props.singleRow && !user?.isPremium ? " listAd" : " hidden")
                }
              >
                <Ad type={"box"} />
              </div>
            )}
            {props.videos?.length === 0 && props.listComplete ? (
              <div className="noVideos">No videos found</div>
            ) : props.videos?.length === 0 ||
              (props.loadingTopVideo && !props.topVideo) ? (
              <VideoListing
                className="videoListing"
                video={{
                  title: "Loading...",
                  viewCount: 0,
                  publicationDate: new Date(),
                }}
              />
            ) : null}
            {videoArray.map((video, index) => (
              <Fragment key={index}>
                {props.showArmanetRectangle && !user?.isPremium && props.armanetRectanglePosition > 0 && index === props.armanetRectanglePosition && (
                  <div className={GetVideoListingClass()}>
                    <ArmanetAd type="rectangle" />
                  </div>
                )}
                {ShouldShowAd(index) && window.location.pathname !== "/" && (
                  <div
                    className={
                      GetVideoListingClass() +
                      (!props.singleRow && !user?.isPremium
                        ? " listAd"
                        : " hidden")
                    }
                  >
                    <Ad type={"box"} />
                  </div>
                )}
                <VideoListing
                  className={GetVideoListingClass()}
                  video={video}
                  biggerThumbnails={props.biggerThumbnails}
                />
              </Fragment>
            ))}
            {ShouldShowAd(-1, props.adAtEnd) && (
              <div
                className={
                  GetVideoListingClass() +
                  (!user?.isPremium ? " listAd" : " hidden")
                }
              >
                <Ad type={"box"} />
              </div>
            )}
          </div>
        </div>
        {isMobile && isOnSingleVideoPage && <Ad type="banner" />}
      </div>
    </>
  );
}

export default VideoListMultiRow;
